import { render, staticRenderFns } from "./ChartsDonutAndColumns.vue?vue&type=template&id=7043045a&scoped=true&"
import script from "./ChartsDonutAndColumns.vue?vue&type=script&lang=js&"
export * from "./ChartsDonutAndColumns.vue?vue&type=script&lang=js&"
import style0 from "./ChartsDonutAndColumns.vue?vue&type=style&index=0&id=7043045a&scoped=true&lang=scss&"
import style1 from "./ChartsDonutAndColumns.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7043045a",
  null
  
)

export default component.exports